var map = {
	"./一站式大数据平台.jpg": 6263,
	"./数字供应链一站式竞价平台.png": 7847,
	"./智慧园区数智平台.jpg": 3120,
	"./智能运维平台.png": 2785,
	"./知识图谱系统.jpg": 1503
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8613;